<template>
    <div>
        <div class="top-area" v-if="content.areas[0].content">
            <render-editor-js :content="content.areas[0].content" :component="{}"/>
        </div>

        <b-field class="text-input-field" :type="{'is-danger': content.required && !data[content.id]}" :message="(content.required) ? '* Response is required.' : ''">
            <b-input type="textarea" v-model="data[content.id]" :required="content.required" @blur="saveData"/>
        </b-field>

        <div class="bottom-area" v-if="content.areas[1].content">
            <render-editor-js :content="content.areas[1].content" :component="{}"/>
        </div>
    </div>
</template>

<script>

    import RenderEditorJs from "./RenderEditorJs.vue";

    export default {
        components: {RenderEditorJs},
        props: ['content', 'data'],
        methods: {
            saveData() {
                let payload = {
                    block: JSON.stringify(this.content),
                    field: this.content.id,
                    value: this.data[this.content.id]
                };

                this.$emit('saveData', payload);
            }
        }
    };
</script>

<style lang="scss">
    .text-input-field {
        padding: 0 2rem 1.2rem;
    }

    .top-area {
        .render-paragraph {
            margin-bottom: 0 !important;
            padding-bottom: 10px !important;
        }
    }
</style>
